import { Box, Checkbox, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

const CONFIDENTIALITY_NOTICE =
  'Screening conducted privately. Patient counseled on confidentiality limitations of electronic records.'

const LabelText = ({ label }: { label: string }) => (
  <Text fontSize="xs" fontWeight={600} color="gray.500" _dark={{ color: 'gray.400' }} mb={0.5}>
    {label}
  </Text>
)

export const DvIpvScreeningView = ({ data }: { data: FieldMapValue }) => {
  const screening = data?.dvIpvScreening as
    | {
        screened?: boolean
        result?: string
        dismissedReason?: string
        followUpPlan?: string
        safetyPlanProvided?: boolean
        resourcesProvided?: boolean
        referralMade?: boolean
      }
    | undefined

  if (!screening) return null

  const {
    screened,
    result,
    dismissedReason,
    followUpPlan,
    safetyPlanProvided,
    resourcesProvided,
    referralMade,
  } = screening
  const concernsIdentified = result === 'concerns-identified'

  return (
    <VStack align="flex-start" spacing={2} w="100%">
      <SectionLabel>DV/IPV Screening</SectionLabel>

      {screened === true && (
        <Text fontSize="sm">
          Screening conducted —{' '}
          {concernsIdentified ? 'concerns identified' : 'no concerns identified'}
        </Text>
      )}

      {screened === false && (
        <Text fontSize="sm" color="gray.500" _dark={{ color: 'gray.400' }}>
          Not screened today
          {dismissedReason ? ` — ${dismissedReason}` : ''}
        </Text>
      )}

      {concernsIdentified && (
        <Box w="100%" pl={2} borderLeft="2px solid" borderColor="orange.300">
          <VStack align="flex-start" spacing={1.5}>
            {safetyPlanProvided != null && (
              <Checkbox isChecked={safetyPlanProvided} isReadOnly size="sm">
                <Text fontSize="sm">Safety plan provided</Text>
              </Checkbox>
            )}
            {resourcesProvided != null && (
              <Checkbox isChecked={resourcesProvided} isReadOnly size="sm">
                <Text fontSize="sm">Community resources provided</Text>
              </Checkbox>
            )}
            {referralMade != null && (
              <Checkbox isChecked={referralMade} isReadOnly size="sm">
                <Text fontSize="sm">Referral made</Text>
              </Checkbox>
            )}
            {followUpPlan && (
              <Box>
                <LabelText label="Follow-up plan" />
                <Text fontSize="sm" whiteSpace="pre-wrap">
                  {followUpPlan}
                </Text>
              </Box>
            )}
          </VStack>
        </Box>
      )}

      {concernsIdentified && (
        <Text
          fontSize="xs"
          color="gray.500"
          _dark={{ color: 'gray.400' }}
          fontStyle="italic"
          mt={1}>
          {CONFIDENTIALITY_NOTICE}
        </Text>
      )}
    </VStack>
  )
}
